import React from 'react'
import styles from "./RegisterLogo.module.css"

function RegisterLogo() {
    return (
        <img src={"registration_preview.png"} alt="Student Register" className={styles.RegisterImage} />
    )
}

export default RegisterLogo